import { useState } from "react";
import { Box, Fade, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { a11yProps } from "../../features/TabPanel/TabPanel.partial";
import { TabPanel } from "../../features/TabPanel/TabPanel.component";
import { CustomColoredTabs } from "../CustomColoredTabs/CustomColoredTabs.component";
import { CustomColoredTab } from "../CustomColoredTabs/CustomColoredTab.component";
import CateringSerivceList from "./Catering/catering-list.component";
import RoomlayoutSerivceList from "./Roomlayout/roomlayout-list.component";

/**
 * @version 0.1.0
 */
export const ServiceItemManagement = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [tabState, setTabState] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent<{}>, newValue: number) =>
    setTabState(newValue);

  return (
    <Fade in>
      <Box sx={{ "& > *": { margin: theme.spacing(1) } }} data-testid="service-mgmt-tabs-parent">
        <CustomColoredTabs value={tabState} onChange={handleTabChange}>
          <CustomColoredTab
            index={0}
            data-testid={"catering-tab"}
            label={t("Manage Catering")}
            {...a11yProps(0)}
          />
          <CustomColoredTab
            index={1}
            data-testid={"roomlayout-tab"}
            label={t("Manage Roomlayout")}
            {...a11yProps(1)}
          />
        </CustomColoredTabs>

        {/* list of catering service */}
        <TabPanel value={tabState} index={0}>
          <CateringSerivceList />
        </TabPanel>

        {/* list of room layout */}
        <TabPanel value={tabState} index={1}>
          <RoomlayoutSerivceList />
        </TabPanel>
      </Box>
    </Fade>
  );
};
